"use client";

import { LogOut } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
};

export function SignOutDialog({ open, onOpenChange, onConfirm }: Props) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="gap-0 overflow-hidden border-border/50 bg-background p-0 shadow-[0_32px_80px_-28px_rgba(0,0,0,0.78)] sm:max-w-[440px]">
        <div className="border-b border-border/40 bg-gradient-to-br from-muted/40 via-background to-background px-8 pb-7 pt-8">
          <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-2xl border border-border/50 bg-background/90 shadow-sm">
            <LogOut
              className="size-5 text-foreground/70"
              strokeWidth={1.75}
              aria-hidden
            />
          </div>
          <AlertDialogHeader className="space-y-3 text-left">
            <AlertDialogTitle className="font-sans text-[20px] font-[700] leading-snug tracking-[-0.03em] text-foreground">
              Sign out?
            </AlertDialogTitle>
            <AlertDialogDescription className="font-sans text-[14px] leading-[1.65] text-muted-foreground">
              You&apos;ll be returned to the login screen. Your notebooks and
              workspaces stay saved for when you sign back in.
            </AlertDialogDescription>
          </AlertDialogHeader>
        </div>

        <AlertDialogFooter className="gap-3 px-8 pb-8 pt-5 sm:justify-end">
          <AlertDialogCancel className="mt-0 h-11 rounded-xl border-border/70 px-5 text-[13px] font-medium">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            className="h-11 rounded-xl bg-foreground px-6 text-[13px] font-medium text-background hover:bg-foreground/90"
            onClick={onConfirm}
          >
            Sign out
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
